<template>
  <v-row justify="center">
    <v-col
      cols="12"
    >
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              lg="12"
            >
              <v-form ref="form_all">
                <v-tabs
                  centered
                  show-arrows
                >
                  <v-tab
                    v-for="(tab, i) in tabs"
                    :key="i"
                  >
                    <v-icon left>
                      {{ tab.icon }}
                    </v-icon>
                    {{ tab.text }}
                  </v-tab>
                  <v-tab-item>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.created"
                          label="Дата создания"
                          type="date"
                          readonly
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.number"
                          label="Системный номер"
                          readonly
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-select
                          v-model="form.state"
                          label="Системный номер"
                          :items="select.state"
                          :disabled="view"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          v-if="$store.state.access[12][5]"
                          v-model="form.client"
                          clearable
                          :filter="client_filter"
                          :items="select.clients"
                          item-value="id"
                          label="Поиск клиента"
                          :disabled="view"
                          :loading="search.client.loading"
                          :search-input.sync="search.client.text"
                          hide-no-data
                          hint="Введите минимум три символа для поиска"
                        >
                          <template v-slot:selection="{item}">
                            <v-list>
                              <v-list-item-content>
                                <v-list-item-title> {{ item.legal.name.short }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list>
                          </template>
                          <template v-slot:item="{item}">
                            <v-list two-line>
                              <v-list-item-content>
                                <v-list-item-title>  {{ item.legal.name.short }}</v-list-item-title>
                                <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="form.name"
                          label="Название места обслуживания"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="form.address"
                          label="Фактический адрес"
                          name="address"
                          :disabled="view"
                          @input="adress_input"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="form.comment"
                          label="Примечание"
                          :disabled="view"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row>
                      <v-col cols="12">
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>Режим работы</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-menu
                                    ref="menu1"
                                    v-model="menu.from"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="form.schedule.from"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                    :disabled="view"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="form.schedule.from"
                                        label="Время начала обслуживания"
                                        prepend-icon="mdi-clock-time-four-outline"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                      />
                                    </template>
                                    <v-time-picker
                                      v-if="menu.from"
                                      v-model="form.schedule.from"
                                      format="24hr"
                                      full-width
                                      @click:minute="$refs.menu1.save(form.schedule.from)"
                                    />
                                  </v-menu>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                >
                                  <v-menu
                                    ref="menu2"
                                    v-model="menu.to"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="form.schedule.to"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                    :disabled="view"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="form.schedule.to"
                                        label="Время окончания обслуживания"
                                        prepend-icon="mdi-clock-time-four-outline"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                      />
                                    </template>
                                    <v-time-picker
                                      v-if="menu.to"
                                      v-model="form.schedule.to"
                                      format="24hr"
                                      full-width
                                      @click:minute="$refs.menu2.save(form.schedule.to)"
                                    />
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header>Контактные телефоны</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row
                                v-for="(item, index) in form.phones"
                                :key="'phone_' + index"
                              >
                                <v-col cols="4">
                                  <v-text-field
                                    v-model="item.number"
                                    label="Номер телефона"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col cols="4">
                                  <v-select
                                    v-model="item.type"
                                    label="Тип"
                                    :items="select.phone"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col cols="3">
                                  <v-text-field
                                    v-model="item.comment"
                                    label="Комментарий"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col cols="1">
                                  <v-icon
                                    :disabled="view"
                                    @click="form.phones = form.phones.filter(a=>a!=item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <v-icon
                                    :disabled="view"
                                    @click="form.phones.push({})"
                                  >
                                    mdi-plus
                                  </v-icon>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row>
                      <v-col cols="2">
                        <span class="ml-5 my-auto">
                          Геокоординаты
                        </span>
                      </v-col>
                      <v-col cols="5">
                        <v-text-field
                          v-model="form.address_data.geo_lat"
                          label="Широта"
                          readonly
                        />
                      </v-col>
                      <v-col cols="5">
                        <v-text-field
                          v-model="form.address_data.geo_lon"
                          label="Долгота"
                          readonly
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-checkbox
                          v-model="form.show_on_map"
                          label="Отображать место обслуживания на карте?"
                          :disabled="view"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <yandex-map
                          style="width: 100%; height: 600px;"
                          :settings="map.settings"
                          :coords="map.coords"
                          show-all-markers
                          :controls="map.controls"
                        >
                          <ymap-marker
                            v-if="form.address_data && form.address_data.geo_lat"

                            :coords="[form.address_data.geo_lat, form.address_data.geo_lon]"
                            marker-id="index"
                            :hint-content="form.address"
                            :balloon="{header: form.address}"
                            marker-type="placemark"
                          >
                            <div slot="balloon">
                              <p>Адрес: {{ form.address }}</p>
                            </div>
                          </ymap-marker>
                        </yandex-map>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="4"
              lg="2"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              v-if="form.id"
              cols="4"
              lg="2"
              class="text-center"
            >
              <v-btn
                v-if="!view"
                color="primary"
                class="ml-auto"
                @click="save_place(true)"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
            <v-col
              v-else
              cols="8"
              lg="4"
              class="text-right"
            >
              <v-btn
                v-if="!view"
                color="primary"
                class="ml-auto"
                @click="create_place"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
            <v-col
              v-if="form.id"
              cols="4"
              lg="2"
              class="text-right"
            >
              <v-btn
                v-if="!view"
                color="blue darken1 white--text"
                class="ml-auto"
                @click="save_place(false)"
              >
                <span class="mx-3">Применить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>

    <!-- <v-col
      v-if="view"
      cols="12"
      md="4"
    >
      <base-material-tabs color="warning">
        <v-tab v-if="$store.state.access[3][1] || $store.state.access[3][2]">
          События
        </v-tab>
        <v-tab v-if="$store.state.access[5][1] || $store.state.access[5][2]">
          Изменения
        </v-tab>
        <v-tab-item v-if="$store.state.access[3][1] || $store.state.access[3][2]">
          <base-material-card
            class="v-card-profile"
            title="События"
          >
            <v-card-text>
              <v-list-item
                v-for="(item,index) in events"
                :key="index"
                two-line
              >
                <v-list-item-content>
                  <v-list-item-title v-if="item.type>0  && $store.state.dict.events[item.type]">
                    {{ $store.state.dict.events[item.type].name }} {{ item.start }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span v-if="item.user">{{ item.user_item.surname }} {{ item.user_item.name }} {{ item.user_item.patronymic }}</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ item.theme }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon
                    large
                    @click="showEvent(item)"
                  >
                    mdi-eye
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                min-width="100"
                @click="showCreateEvent"
              >
                Создать
              </v-btn>
            </v-card-actions>
          </base-material-card>
        </v-tab-item>
        <v-tab-item v-if="$store.state.access[5][1] || $store.state.access[5][2]">
          <base-material-card
            class="v-card-profile"
            title="История изменений"
          >
            <v-card-text>
              <v-list-group
                v-for="(log,index) in logs"
                :key="index"
              >
                <v-list-item
                  slot="activator"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $store.state.dict.log[log.type] }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="log.user">
                      {{ log.user.surname }} {{ log.user.name }} {{ log.user.patronymic }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ log.date_text }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-card>
                  <v-row
                    align="center"
                    justify="center"
                  >
                    <pre class="ma-5"><code class="json">{{ log.diff }}</code></pre>
                  </v-row>
                </v-card>
              </v-list-group>
            </v-card-text>
            <v-card-actions>
              <v-btn color="success" width=150 @click="$router.push('/admin/log/list?entity=' + form.id)">Показать все</v-btn>
            </v-card-actions>
          </base-material-card>
        </v-tab-item>
      </base-material-tabs>
    </v-col> -->
    <v-dialog
      v-model="dialog.event.show"
      scrollable
      persistent
    >
      <event-form
        :create="dialog.event.create"
        :view="dialog.event.view"
        :change="dialog.event.change"
        :data="dialog.event.data"
        :show="dialog.event.show"
        @close="dialog.event.show = false, load_events()"
      />
    </v-dialog>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff'
  import EventForm from './../EventForm'
  import { yandexMap, ymapMarker } from 'vue-yandex-maps'
  export default {
    components: { yandexMap, ymapMarker, EventForm },
    props: ['create', 'change', 'view', 'show', 'item'],
    data: () => ({
      map: {
          coords: [54.735147, 55.958727],
          settings: {
            apiKey: 'df228d50-f05d-46b7-b2a7-afccf3a31cb3',
            lang: 'ru_RU',
            coordorder: 'latlong',
            version: '2.1',

          },
          controls: ['geolocationControl', 'rulerControl', 'typeSelector', 'zoomControl'],
          clusterOptions: {
            points: {
              clusterDisableClickZoom: true,
              clusterOpenBalloonOnClick: true,
            },
          },
        },
      menu: {
        from: false,
        to: false
      },
      event: {
        items: [],
        form: {
          client: '',
        },
      },
      selected: {
      },
      info: {

      },
      loader: {
        show: false,
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },

      },
      events: [

      ],
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'filename',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
        ],
      },
      tabs: [
        {
          text: 'Основные',
          icon: 'mdi-receipt'
        }, {
          text: 'Справочная информация',
          icon: 'mdi-receipt'
        }, {
          text: 'Геоданные',
          icon: 'mdi-receipt'
        }
      ],
      data: {
        phone: '',
      },
      form: {
        name: '',
        address: '',
        address_data: {},
        state: 0,
        comment: '',
        schedule: {
          from: null,
          to: null
        },
        phones: [],
        client: null
      },
      logs: [],
      dict: {
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Юридический адрес',
          2: 'Фактический адрес',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
      },
      select: {
        clients: [],
        phone: [
          { value: 1, text: 'Мобильный' },
          { value: 2, text: 'Домашний' },
        ],
        document: [
          { value: 1, text: 'Паспорт' },
          { value: 2, text: 'Водительское удостоверение' },
          { value: 10, text: 'Иное' },
        ],
        type: [
          { value: 1, text: 'Собственник ТС' },
          { value: 2, text: 'Водитель' },
          { value: 10, text: 'Иное' },
        ],
        social: [
          { value: 1, text: 'ВКонтакте' },
          { value: 2, text: 'Facebook' },
          { value: 3, text: 'Instagram' },
          { value: 4, text: 'Twitter' },
        ],
        event: [
          { value: 1, text: 'Звонок' },
        ],
        doc_type: [
          { value: 1, text: 'Свидетельство о регистрации ТС' },
          { value: 2, text: 'Паспорт ТС' },
          { value: 3, text: 'Паспорт самоходной машины' },
          { value: 4, text: 'Аналогичный документ' },
        ],
        state: [
          { value: 0, text: 'Активный' },
          { value: 1, text: 'Заблокирован' },
        ]
      },
      suggestion: {
        address: false
      },
      search: {
        client: {
          loading: false,
          text: ''
        },
      },
    }),
    computed: {
      title: {
        get: function () {
          if (this.create) return 'Создание'
          if (this.change) return 'Изменение'
          if (this.view) return 'Просмотр'
          return ''
        },
      },
    },
    watch: {
      'search.client.text': function () {
        if (this.search.client.text) { this.load_clients(this.search.client.text) }
      },
      show: function () {
        if (this.show) {
          if (this.change) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }

          if (this.view) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }
          if (this.create) {
            this.form = {

            }
          }
        }
      },
    },
    mounted: function () {
      if (this.create) {
        this.form.created = moment().format('YYYY-MM-DD')
      }
      var id = null
      if (this.item && this.item.id) id = this.item.id
      else
        if (this.$route.query.id && (this.view || this.change)) id = this.$route.query.id
      if (id) {
        this.axios.post('/api/place/list', { id: id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data[0]
              if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
              this.form.schedule = this.form.schedule || {}
              this.form.phones = this.form.phones || []
              this.form.address_data = this.form.address_data || {}
              if (this.form.client) {
                this.load_clients_id(this.form.client)
              }
              this.load_events()
              this.load_logs()
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    methods: {
      client_filter: function (item, query, text) {
        if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {
          search: text,
          limit: 10
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      load_clients_id: function (id) {
        if (!id) return
        this.axios.post('/api/client/list', {
          id: id
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      get_color: function (item, type) {
        return 'white'
      },
      load_events: function () {
        this.axios.post('/api/event/list', {
          place: this.form.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (const x in result.data.data) {
                if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
                result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
              }
              this.events = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      load_logs: function () {
        this.axios.post('/api/log/list', { entity: this.form.id, limit: 5 })
          .then(result => {
            if (!result.data.error) {
              this.logs = result.data.data || []
              for (const x in this.logs) {
                this.logs[x].date_text = moment(this.logs[x].date).format('DD.MM.YYYY HH:mm')
                this.logs[x].diff = (diff(JSON.parse(this.logs[x].old), (JSON.parse(this.logs[x].change))))
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          place: this.form.id,
          place_item: this.form,
        }
        console.log(this.dialog.event.data)
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      open_file: function (id, item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      adress_input: function (item) {
        if (!this.suggestion.address) {
          console.log('[name=address]')
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.address = data.unrestricted_value
              this.form.address_data = data.data
            },
          })
        }
      },
      create_place: function () {
        this.axios.post('/api/place/create', this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                if (!this.item) this.$router.go(-1)
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
      },
      save_place: function (save) {
          this.axios.post('/api/place/save', this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                // if (!this.item) this.$emit('view', this.form.id)
                if (save) {
                  this.$router.go(-1)
                }
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
      },
    },
  }
</script>
